declare var ENVIRONMENT: string;

const RELEASE = ENVIRONMENT == "production";

class ConsoleUtil {
    static red(message: string, object?: any) {
        this.logWithColor(message, 0xfc2c03, object);
    }

    static yellow(message: string, object?: any) {
        this.logWithColor(message, 0xfce703, object);
    }

    static orange(message: string, object?: any) {
        this.logWithColor(message, 0xff7300, object);
    }

    static green(message: string, object?: any) {
        this.logWithColor(message, 0x00ff66, object);
    }

    static logWithColor(message: string, color: number | string, object?: any) {
        let convertedColor: string; 
        
        if (typeof color == "string") {
          convertedColor = color;
        } else {
          convertedColor =
              "#" + ("00000" + (color | 0).toString(16)).substr(-6);
        }

        this.log(
            "%c" + message,
            "color:" + convertedColor + ";font-weight:bold;"
        );
        if (object) {
            this.log("\t", object);
        }
    }

    static log(...data:any[]) {
        if (!RELEASE) {
            console.log(...data);
        }
    }
}

export default ConsoleUtil;
